export var FetchMissingChangesError;
(function (FetchMissingChangesError) {
    FetchMissingChangesError[FetchMissingChangesError["ResponseError"] = 1] = "ResponseError";
    FetchMissingChangesError[FetchMissingChangesError["CGIError"] = 2] = "CGIError";
    FetchMissingChangesError[FetchMissingChangesError["ResultError"] = 3] = "ResultError";
    FetchMissingChangesError[FetchMissingChangesError["ParamError"] = 4] = "ParamError";
    FetchMissingChangesError[FetchMissingChangesError["Timeout"] = 5] = "Timeout";
})(FetchMissingChangesError || (FetchMissingChangesError = {}));
//# sourceMappingURL=revision-constants.js.map